export default __webpack_public_path__ + "static/media/ua.f8cca1b6.svg";